import { StandardQuizQuestion } from '@/types/quizTypes';

export const REACT_COMPONENTS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "react-comp-1",
    question: "What is the main difference between functional and class components in React?",
    options: [
      "Functional components are faster",
      "Functional components use hooks for state, class components use this.state",
      "Class components can't have props",
      "Functional components can't return JSX"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Modern React favors functional components with hooks (useState, useEffect) over class components with lifecycle methods and this.state. Functional components are simpler and more concise.",
    category: "components",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "react-comp-2",
    question: "What is JSX?",
    options: [
      "A JavaScript framework",
      "A syntax extension for JavaScript that looks like HTML",
      "A CSS preprocessor",
      "A database query language"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "JSX is a syntax extension that allows writing HTML-like code in JavaScript. It gets compiled to React.createElement() calls by tools like Babel.",
    category: "jsx",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "react-comp-3",
    question: "How do you pass data from a parent component to a child component?",
    options: [
      "Using state",
      "Using props",
      "Using context",
      "Using refs"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Props (properties) are the primary way to pass data from parent to child components. They are read-only and flow downward in the component tree.",
    category: "props",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "react-comp-4",
    question: "What does the `children` prop represent?",
    options: [
      "An array of child component names",
      "Content placed between opening and closing tags of a component",
      "The number of child components",
      "Child component state"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "The children prop contains everything placed between a component's opening and closing tags, enabling component composition and wrapper patterns.",
    category: "props",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "react-comp-5",
    question: "What is the correct way to handle a button click in React?",
    options: [
      "onClick=\"handleClick()\"",
      "onClick={handleClick}",
      "onclick={handleClick}",
      "onClick={handleClick()}"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "In React, event handlers are passed as functions (not strings) using camelCase. Pass the function reference (onClick={handleClick}) not the invocation.",
    category: "events",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "react-comp-6",
    question: "How do you conditionally render a component in React?",
    options: [
      "Using if-else statements directly in JSX",
      "Using ternary operators or && operator",
      "Using switch statements in JSX",
      "React doesn't support conditional rendering"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Conditional rendering uses JavaScript expressions: ternary operators (condition ? <A/> : <B/>), && operator (condition && <Component/>), or variables with if-else outside JSX.",
    category: "conditional-rendering",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "react-comp-7",
    question: "What is component composition in React?",
    options: [
      "Writing CSS for components",
      "Building complex UIs from smaller, reusable components",
      "Deploying components to production",
      "Testing components"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Component composition is the pattern of building complex UIs by combining smaller, focused components. This promotes reusability and maintainability.",
    category: "composition",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "react-comp-8",
    question: "What happens when you call setState in React?",
    options: [
      "State updates immediately",
      "State updates are batched and component re-renders",
      "Component is destroyed",
      "Props are updated"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "setState is asynchronous and batched for performance. React schedules a re-render when state changes, updating the virtual DOM first, then efficiently updating the real DOM.",
    category: "state",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateReactComponentsQuiz = () => ({
  questions: REACT_COMPONENTS_QUIZ,
  passThreshold: 75,
  timeLimit: 600,
  category: 'react-fundamentals'
});
